import Vue from "vue"
import Vuex from "vuex"
import langs from "../../common/store/langs"

import CourseSliderComponent from "@profile/components/dashboard/CourseSliderComponent.vue"

Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        langs
    }
})

const container = document.getElementById("sales-block")

if (container) {
    const course = JSON.parse(container.dataset.course || "{}")

    store.dispatch("langs/fetchLangs", "course-store").then(() => {
        new Vue({
            el: "#sales-block",
            store,
            render: h =>
                h(CourseSliderComponent, {
                    props: {
                        maxWidth: "100%",
                        mode: "salesBlock",
                        course: course
                    }
                })
        })
    })
}
